import Typography from '@mui/material/Typography';

import { CollapsibleCard } from '@/components/ui/CollapsibleCard';

import { State } from '../State';

export function CollapsibleCardExamples() {
  return (
    <>
      <State title="Open" note="The body stays mounted when folded, so typing survives.">
        <CollapsibleCard
          title="Details"
          description="Open on first render, because it is what the page is for."
          defaultExpanded
        >
          <Typography variant="body2">The section&apos;s content.</Typography>
        </CollapsibleCard>
      </State>

      <State title="Closed">
        <CollapsibleCard title="Billing" description="Folded until it is wanted.">
          <Typography variant="body2">
            Twenty fields nobody has to scroll past.
          </Typography>
        </CollapsibleCard>
      </State>
    </>
  );
}
